import PreloadGeneratorContainer from './preload-generator-container';

export default PreloadGeneratorContainer;
